// src/config.ts

// Validate required environment variables
if (!process.env.REACT_APP_BASE_URL) {
  throw new Error('REACT_APP_BASE_URL environment variable is required but not set');
}
if (!process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY) {
  throw new Error('REACT_APP_STRIPE_PUBLISHABLE_KEY environment variable is required but not set');
}

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const API_URL = `${BASE_URL}/api`;
export const PLACEHOLDER_EVENT_IMAGE = 'https://myeventshop-images.s3.eu-west-1.amazonaws.com/events/placeholder-event.jpg';

// Timezone configuration
export const DEFAULT_TIMEZONE = 'Europe/Dublin'; // Ireland timezone

// Stripe configuration
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
